<template>
  <div class="flex flex-col bg-white rounded-lg">
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="py-2 align-middle inline-blocksm:px-6 lg:px-8">
        <div
          class="shadow overflow-y-auto border-b border-gray-200 sm:rounded-lg scrollbar-w-2 scrollbar-track-gray-lighter scrollbar-thumb-rounded scrollbar-thumb-gray h-128 max-h-full"
        >
          <table class="min-w-full divide-y divide-gray-200 table-collapse">
            <thead>
              <tr>
                <th
                  class="z-5 sticky top-0 px-6 px-4 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase"
                >
                  {{ $t('message.wms.itemstable.codigo') }}
                </th>
                <th
                  class="z-5 sticky top-0 px-6 py-4 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase"
                >
                  {{ $t('message.wms.itemstable.producto') }}
                </th>
                <th
                  class="z-5 sticky top-0 px-6 py-4 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase"
                >
                  {{ $t('message.wms.itemstable.ubicacion') }}
                </th>
                <th
                  class="z-5 sticky top-0 px-6 py-4 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase"
                >
                  {{ $t('message.wms.itemstable.ingreso') }}
                </th>
                <th
                  class="z-5 sticky top-0 px-6 py-4 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase"
                >
                  {{ $t('message.wms.itemstable.vencimiento') }}
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-300">
              <tr v-for="item in items" :key="item.id">
                <td
                  class="px-6 py-3 whitespace-nowrap text-xs leading-5 text-gray-900"
                >
                  {{ item.code }}
                </td>
                <td
                  class="px-6 py-3 whitespace-nowrap text-xs leading-5 text-gray-700"
                >
                  {{ item.name }}
                </td>
                <td
                  class="px-6 py-3 whitespace-nowrap text-xs leading-5 text-gray-700"
                >
                  {{ item.location }}
                </td>
                <td
                  class="px-6 py-3 whitespace-nowrap text-xs leading-5 text-gray-700"
                >
                  {{ item.date_i }}
                </td>
                <td
                  class="px-6 py-3 whitespace-nowrap text-xs leading-5 text-gray-700"
                >
                  {{ item.expiration }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'items-table',
  props: {
    searchinput: String,
    filtertype: String
  },
  created() {
    this.fetchItems();
  },
  data() {
    return {
      items: []
    };
  },
  watch: {
    searchinput() {
      this.fetchItems();
    },
    filtertype() {
      this.fetchItems();
    }
  },
  methods: {
    async fetchItems() {
      const response = await this.$http.get(
        `wms/storageboxes?filtertype=${this.filtertype}&searchinput=${this.searchinput}`
      );
      this.items = response.data.storageboxes;
    }
  }
};
</script>
